module.exports = __webpack_public_path__ + "static/media/icon-minus-blue.e7bcd70e.svg";